if (!customElements.get('cart-card-message-edit')) {
  class CartCardMessageEdit extends HTMLElement {
    constructor() {
      super();

      this.item = null;
    }

    connectedCallback() {
      document.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-edit-card-message]');
        if (trigger) {
          this.open(event, trigger);
        }
      });

      this.form = this.querySelector('[data-message-edit-form]');
      this.addEventListener('submit', this.onSubmit.bind(this));

      this.addEventListener('mousedown', this.close.bind(this));

      this.querySelector('[data-message-edit-message]').addEventListener('input', this.inputChange.bind(this));
    }

    open(event, trigger) {
      event.preventDefault();
      event.stopImmediatePropagation();

      trigger = trigger || event.target;

      this.item = JSON.parse(trigger.dataset.editCardMessage);
      this.item.properties = this.formatProperties(this.item.properties);
      
      this.renderItemContent();
      
      this.classList.add('open');
    }

    close(event) {
      const ignore = [
        this.querySelector('[data-message-edit-cancel]')
      ];
      
      if (event && !ignore.includes(event.target) && !event.target.isEqualNode(event.target.closest('cart-card-message-edit'))) {
        return;
      }

      if (event) {
        event.preventDefault();
      }
      
      this.classList.remove('open');
    }

    inputChange(event) {
      this.querySelector('[data-message-edit-button]').disabled = event.target.value.length === 0 || event.target.value === this.item.properties.Message;
    }

    onSubmit(event) {
      event.preventDefault();

      this.querySelector('[data-message-edit-button]').disabled = true;
      
      const body = JSON.stringify({
        id: this.item.key,  // The line item ID (key from cart items)
        properties: {
          ...this.item.properties,
          Message: this.querySelector('[data-message-edit-message]').value
        },
        sections: ['cart-drawer']
      });
      
      fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: body
      })
        .then(response => response.json())
        .then(data => {
           // Re-render sections
          if (data.sections) {
            const cartDrawer = document.getElementById('CartDrawer');
            
            if (cartDrawer) {
              const parser = new DOMParser();
              const html = parser.parseFromString(data.sections['cart-drawer'], 'text/html');
              cartDrawer.querySelector('.drawer__inner').innerHTML = html.querySelector('.drawer__inner').innerHTML;
            }
          }

          this.querySelector('[data-message-edit-button]').disabled = false;

          this.close(false); 
        });
    }

    formatProperties(properties) {
      const newProperties = {};
      
      properties.forEach((property) => {
        newProperties[property[0]] = this.decodeHtmlEntities(property[1]);
      });

      return newProperties;
    }

    decodeHtmlEntities(value) {
      if (typeof value !== 'string') return value;

      const textarea = document.createElement('textarea');
      textarea.innerHTML = value;
      return textarea.value;
    }

    renderItemContent() {
      this.querySelector('[data-message-edit-image]').src = this.item.image;
      this.querySelector('[data-message-edit-title]').textContent = this.decodeHtmlEntities(this.item.title);
      this.querySelector('[data-message-edit-message]').value = this.item.properties.Message || '';
      this.querySelector('[data-message-edit-button]').disabled = true;
    }
  }

  customElements.define('cart-card-message-edit', CartCardMessageEdit);
}
